import axios from 'axios';
import { WheelsPricingConfig } from '../../domain/wheels';
import { WHEELS_SERVICE_ENDPOINTS } from './wheels.service.config';

const axiosInstance = axios.create();

export class WheelsService {
  private readonly _endpoints: typeof WHEELS_SERVICE_ENDPOINTS;

  constructor() {
    this._endpoints = { ...WHEELS_SERVICE_ENDPOINTS };
  }

  public async getPriceConfig(): Promise<WheelsPricingConfig> {
    return (await axiosInstance.get(this._endpoints.getPriceConfig)).data.data;
  }
}
